import { BidiModule } from '@angular/cdk/bidi';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { IconDefinition } from '@ant-design/icons-angular';
import { EditOutline, LeftOutline, RightOutline } from '@ant-design/icons-angular/icons';
import { MwcAffixModule } from 'mwc/affix';
import { MwcBadgeModule } from 'mwc/badge';
import { MwcButtonModule } from 'mwc/button';
import { NZ_CONFIG } from 'mwc/core/config';
import { MwcGridModule } from 'mwc/grid';
import { MwcI18nModule } from 'mwc/i18n';
import { MwcIconModule } from 'mwc/icon';
import { MwcInputModule } from 'mwc/input';
import { MwcMenuModule } from 'mwc/menu';
import { MwcMessageModule } from 'mwc/message';
import { MwcPopoverModule } from 'mwc/popover';
import { MwcSelectModule } from 'mwc/select';
import { ColorSketchModule } from 'ngx-color/sketch';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';

import { environment } from '../environments/environment';
import { DEMOComponent } from './_demo/demo.component';
import { AppComponent } from './app.component';
import { routes } from './app.routing.module';
import { FooterModule } from './footer/footer.module';
import { HeaderModule } from './header/header.module';
import { MwcContributorsListModule } from './share/contributors-list/contributors-list.module';
import { FixedWidgetsModule } from './share/fixed-widgets/fixed-widgets.module';
import { MwcNavBottomModule } from './share/nav-bottom/nav-bottom.module';
import { SideComponent } from './side/side.component';

const icons: IconDefinition[] = [LeftOutline, RightOutline, EditOutline];

@NgModule({
  declarations: [AppComponent, DEMOComponent, SideComponent],
  imports: [
    BidiModule,
    BrowserModule.withServerTransition({ appId: 'docs' }),
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MwcNavBottomModule,
    ColorSketchModule,
    MwcIconModule.forRoot(icons),
    MwcGridModule,
    MwcAffixModule,
    MwcMenuModule,
    MwcI18nModule,
    MwcSelectModule,
    MwcMessageModule,
    MwcPopoverModule,
    MwcButtonModule,
    MwcInputModule,
    MwcBadgeModule,
    HttpClientJsonpModule,
    HeaderModule,
    FooterModule,
    MwcContributorsListModule,
    FixedWidgetsModule,
    QuicklinkModule,
    RouterModule.forRoot(
      routes,
      environment.production
        ? {
            preloadingStrategy: QuicklinkStrategy,
            scrollPositionRestoration: 'enabled'
          }
        : { preloadingStrategy: QuicklinkStrategy }
    ),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production && !environment.preProduction })
  ],
  providers: [
    Title,
    {
      provide: NZ_CONFIG,
      useValue: {
        codeEditor: {
          monacoEnvironment: { globalAPI: true }
        },
        icon: { mwcTwotoneColor: '#1890ff' },
        global: { mwcDirection: 'ltr' }
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
